import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import Tab from '@mui/material/Tab'
import {FC, useEffect, useMemo, useRef, useState} from 'react'
import {useDispatch} from 'react-redux'
import {GetStickers, messageTypes, SendMessage, useStickersData} from 'entities/messages'
import {StickerPack} from 'entities/messages/ui/stikerPack'
import {mediaVariants, names} from 'shared/lib'
import {Smile} from 'shared/ui/icons'
import {Tabs} from 'shared/ui/tabs'
import styles from './styles.module.scss'

type ChatSendStickersAndEmojiProps = {
  addEmojiHandler: (emoji: string) => void
  onSendStickerHandler?: () => void
  userId: string
  iconClassName?: string
  classNamePopup?: string
}

export const SendStickersAndEmoji: FC<ChatSendStickersAndEmojiProps> = (props) => {
  const {addEmojiHandler, onSendStickerHandler, userId, iconClassName, classNamePopup} = props
  const dispatch = useDispatch()
  const [isHover, setIsHover] = useState(false)
  const [activeTab, setActiveTab] = useState<'emoji' | 'stickers'>('stickers')
  const packsRef = useRef<HTMLDivElement>(null)
  const packRef = useRef<HTMLDivElement[]>([])
  const stickerPacks = useStickersData()
  const stickerPacksCategoriesMock = useMemo(() => stickerPacks.map((pack) => pack.stickers[0].data.url), [stickerPacks])
  const [stickerId, setStickerId] = useState(0)
  const {refetch, isFetching} = SendMessage(userId, {id: stickerId}, messageTypes.sticker, dispatch)
  const {refetch: loadStickers} = GetStickers(dispatch)

  useEffect(() => {
    if (!stickerId || isFetching) return

    refetch().then(({status, error}) => {
      if (status === 'error') throw error

      setIsHover(false)
      onSendStickerHandler && onSendStickerHandler()
      loadStickers().catch(console.error)
      setStickerId(0)
    }).catch(console.error)
  }, [stickerId])

  const categoriesChangeHandler = (index: number) => {
    if (!packsRef.current) return

    const containerTop = packsRef.current.getBoundingClientRect().top
    const elementTop = packRef.current[index].getBoundingClientRect().top

    packsRef.current.scrollBy({
      top: elementTop - containerTop,
      behavior: 'smooth'
    })
  }

  const onClickStickerHandler = (stickerId: number) => {
    setStickerId(stickerId)
  }

  return (
    <div
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
      onMouseLeave={() => setIsHover(false)}
      className={styles.smileWrapper}
    >
      <div className={`${styles.smileIcon} ${iconClassName || ''}`}>
        <Smile />
      </div>

      <div className={names(styles.popup, isHover && styles.active, classNamePopup)}>
        <div className={styles.wrapper}>
          <Tabs
            value={activeTab}
            onChange={(_, newValue) => setActiveTab(newValue)}
            className={styles.tabs}
            classes={{flexContainer: styles.tabsFlexContainer}}
          >
            <Tab
              value='stickers'
              label={<div>Stickers</div>}
              className={styles.tab}
            />
            <Tab
              value='emoji'
              label={<div>Emoji</div>}
              className={styles.tab}
            />
          </Tabs>
          {
            activeTab === 'emoji'
              ? <div className={styles.emojiWrapper}>
                <Picker
                  data={data}
                  onEmojiSelect={(emoji: {native: string}) => addEmojiHandler(emoji.native)}
                  navPosition='bottom'
                  previewPosition='top'
                  skinTonePosition='none'
                  emojiButtonRadius='8px'
                  theme='light'
                  dynamicWidth
                />
              </div>
              : <div className={styles.stickersWrapper}>
                <div className={`${styles.stickerPacksWrapper} ${styles.customScroll}`} ref={packsRef}>
                  {
                    stickerPacks.map((stickerPack, index: number) => <div
                      key={stickerPack.name}
                      ref={(element) => element && (packRef.current[index] = element)}
                    >
                      <StickerPack stickerPack={stickerPack} onClick={onClickStickerHandler} />
                    </div>)
                  }
                </div>
                <div className={styles.categoriesWrapper}>
                  {stickerPacksCategoriesMock.map((item, index) =>
                    <img
                      key={index}
                      src={item + mediaVariants.square256}
                      alt='sticker'
                      className={styles.categoriesItem}
                      onClick={() => categoriesChangeHandler(index)}
                    />)}
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  )
}